import { render, staticRenderFns } from "./lunbo.vue?vue&type=template&id=aea0d044&scoped=true&"
import script from "./lunbo.vue?vue&type=script&lang=js&"
export * from "./lunbo.vue?vue&type=script&lang=js&"
import style0 from "./lunbo.vue?vue&type=style&index=0&id=aea0d044&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea0d044",
  null
  
)

component.options.__file = "lunbo.vue"
export default component.exports